import React, { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import Sections from "./Sections";
import Contact from "./Contact/Contact";

const scrollToHashId = (rawHash) => {
  const id = rawHash.replace(/^#/, "").trim();
  if (!id) return false;
  const el = document.getElementById(id);
  if (!el) return false;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
  return true;
};

const HomePage = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    const hashFromRouter =
      location.hash && location.hash.length > 1 ? location.hash : "";
    const hashFromWindow =
      typeof window !== "undefined" ? window.location.hash || "" : "";
    const hash = hashFromRouter || hashFromWindow;

    if (!hash || hash === "#") return undefined;

    let cancelled = false;
    const tryScroll = () => {
      if (cancelled) return;
      scrollToHashId(hash);
    };

    tryScroll();
    const t0 = window.setTimeout(tryScroll, 0);
    const t1 = window.setTimeout(tryScroll, 100);
    const raf = requestAnimationFrame(() => {
      requestAnimationFrame(tryScroll);
    });

    return () => {
      cancelled = true;
      window.clearTimeout(t0);
      window.clearTimeout(t1);
      cancelAnimationFrame(raf);
    };
  }, [location.pathname, location.hash]);

  return (
    <>
      <Sections />
      <Contact />
    </>
  );
};

export default HomePage;
